import PropTypes from 'prop-types';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';

import LabelAsHTML from './LabelAsHTML';
import { SLASH_MO } from '../constants/labels';
import { setClassNames } from '../utils/utility';

const PricingSummaryPayments = ({
	price,
	paymentLabelSize,
	paymentPrice,
	paymentPriceSize,
	handleHelpCircleIcon
}) => {
	if (price && !price.isFinalPrice && paymentPrice) {
		return (
			<span className="flex-grow-1">
				<span
					className={setClassNames(
						'text-muted',
						'text-nowrap',
						'd-block',
						paymentLabelSize
					)}
				>
					<Common
						render={({ labels }) => {
							return (
								<LabelAsHTML label={labels.get(price.label)} />
							);
						}}
					/>

					<button
						className="text-link line-height-reset help-icon"
						onClick={handleHelpCircleIcon}
					>
						<i className="ddc-icon ddc-icon-help-circle text-muted d-inline-block pl-1" />
					</button>
				</span>
				<strong
					className={setClassNames(
						'line-height-reset',
						paymentPriceSize
					)}
				>
					{paymentPrice}
				</strong>
				<span className="ddc-font-size-small text-muted d-inline line-height-reset">
					<Common
						render={({ labels }) => {
							return labels.get(SLASH_MO);
						}}
					/>
				</span>
			</span>
		);
	}
	return null;
};

PricingSummaryPayments.propTypes = {
	price: PropTypes.shape({
		_type: PropTypes.string.isRequired,
		formatted: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		value: PropTypes.number.isRequired,
		isFinalPrice: PropTypes.bool.isRequired
	}).isRequired,
	paymentLabelSize: PropTypes.string,
	paymentPrice: PropTypes.string.isRequired,
	paymentPriceSize: PropTypes.string,
	handleHelpCircleIcon: PropTypes.func.isRequired
};

PricingSummaryPayments.defaultProps = {
	paymentLabelSize: '',
	paymentPriceSize: ''
};

export default PricingSummaryPayments;



// WEBPACK FOOTER //
// ./src/components/PricingSummaryPayments.jsx